import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
if (window.Laravel?.csrfToken) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = window.Laravel.csrfToken;
}

export const useWishlistStore = defineStore('wishlist', () => {
  const items = ref([]);     // array of { variant_id, code, title, href, price, available, image, ... }
  const loading = ref(false);

  const isInWishlist = (variantId) => {
    if (!variantId) return false;

    return items.value.some(
      p => Number(p.variant_id) === Number(variantId)
    );
  };

  const get = () => {
    loading.value = true;
    return axios.get(window.Laravel.shop.wishlist.list, { headers: { Accept: 'application/json' } })
      .then(({ data }) => {
        items.value = data?.data?.items ?? [];
        return data;
      })
      .finally(() => { loading.value = false; });
  };

  const toggle = (variant_id) => {
    const fd = new FormData();
    fd.append('variant_id', variant_id);
    return axios.post(window.Laravel.shop.wishlist.toggle, fd, { headers: { Accept: 'application/json' } })
      .then(({ data }) => {
        items.value = data?.data?.items ?? [];
        return data;
      });
  };

  const remove = (variant_id) => {
    // Some backends require token in body for DELETE – here we rely on header CSRF
    const url = `${window.Laravel.shop.wishlist.destroy.replace(/\/+$/, '')}/${variant_id}`;
    return axios.delete(url, { headers: { Accept: 'application/json' } })
      .then(({ data }) => {
        // refresh after delete
        return get().then(() => data);
      });
  };

  const moveToCart = (variant_id) => {
    const base = window.Laravel.shop.wishlist.moveToCartBase;
    if (!base) return Promise.resolve(); // optional
    const url = `${base.replace(/\/+$/, '')}/${variant_id}/move-to-cart`;
    const fd = new FormData();
    return axios.post(url, fd, { headers: { Accept: 'application/json' } })
      .then(({ data }) => {
        // after moving, wishlist typically removes the item → refresh
        return get().then(() => data);
      });
  };

  return {
    items,
    loading,
    isInWishlist,
    get,
    toggle,
    remove,
    moveToCart,
  };
});
